import { postData, getData } from './api';
import * as config from '../config';

export const getTransfer = (id) => getData(`${config.postTransferApiUrl}/${id}`);
export const postPretransfer = (data, accessToken) =>
  postData(config.postPretransferApiUrl, data, accessToken);
export const postTransfer = (data, accessToken) =>
  postData(config.postTransferApiUrl, data, accessToken);
